import { removeDriver as removeDriverAction } from '@acorn-portal/shared/src/store/subscription-amend-drivers.slice';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

export const useRemoveDriver = () => {
	const [showRemoveDriverModal, setShowRemoveDriverModal] = useState(false);
	const dispatch = useDispatch();

	const onRemoveDriver = (index: number) => {
		if (index > 0) dispatch(removeDriverAction(index));
		setShowRemoveDriverModal(false);
	};

	return {
		showRemoveDriverModal,
		setShowRemoveDriverModal,
		onRemoveDriver,
	};
};
